export default {
  permissions: {
    // Exact match for the raw string from backend
    'users view': 'View Users',
    'users create': 'Create New Users',
    'users edit': 'Edit Existing Users',
    'users delete': 'Delete Users',
    'roles view': 'View Roles',
    'roles manage': 'Manage Roles & Permissions',
  },
  roles: {
    manager: 'Manager',
    editor: 'Editor',
    viewer: 'Viewer',
  }
}
